<template>
  <div>
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="mb-0 font-medium text-uppercase">
            Notifications <span class="badge badge-primary">{{ count }}</span>
          </h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <button
            class="float-right ml-3 text-white btn btn-primary d-none d-md-block"
            @click="openAddStickerModal()"
          >
            <i class="fas fa-plus"></i> Add new notification
          </button>
          <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
            <ol class="p-0 mb-0 breadcrumb justify-content-end">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Notifications
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <div class="page-content container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-4">
                  <div class="input-group">
                    <span class="input-group-btn">
                      <button
                        type="button"
                        class="btn waves-effect waves-light btn-info"
                      >
                        <i class="fa fa-search"></i>
                      </button>
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search"
                      @change="search()"
                      v-model="textSearch"
                    />
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="text-center">
                  <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Thumbnail</th>
                      <th>Title</th>
                      <th>Descrition</th>
                      <th>Image</th>
                      <th>Url</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :key="index"
                      v-for="(item, index) in items"
                    >
                      <td>{{ item.id }}</td>
                      <td><img :src="item.thumbnail" :alt="item.thumbnail" width="200" v-if="item.thumbnail"/></td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.description }}</td>
                      <td><img :src="item.image" :alt="item.image" width="200" v-if="item.image"/></td>
                      <td>
                        {{ item.url }}
                      </td>
                      <td>
                        <a @click="deleteNotification(item)" style="color: red; cursor: pointer;">Delete</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <aha-modal
      title="Create new notification"
      v-if="showModal"
      @hide="showModal = false"
    >
      <form class="needs-validation" @submit.prevent="sendNotification">
        <div class="d-block form-group">
          <label for="text">Image Thumbnail</label>
          <div>
            <img v-if="notification.thumbnailFull" :src="notification.thumbnailFull" height="100" />
            <input type="file" class="form-control" @change="onChangeThumbnail" accept="image/*" ref="fileInputThumbnail" />
          </div>
        </div>
        <div class="d-block form-group">
          <label for="name">title</label>
          <div>
            <input class="form-control" type="text" v-model="notification.title" name="text" required />
          </div>
        </div>
        <div class="d-block form-group">
          <label for="url">URL</label>
          <div>
            <input class="form-control" type="text" v-model="notification.url" name="url">
          </div>
        </div>
        <div class="d-block form-group">
          <label for="open-tab">Open New Tab <input type="checkbox" v-model="notification.isNewTab" name="open-tab" /></label>
        </div>
        <div class="d-block form-group">
          <label for="text">Image Description</label>
          <div>
            <img v-if="notification.imageFull" :src="notification.imageFull" height="100" />
            <input type="file" class="form-control" @change="onChangeImage" accept="image/*" ref="fileInputImage" />
          </div>
        </div>
        <div class="d-block form-group">
          <label for="rule">Description</label>
          <div>
            <textarea class="form-control" type="text" v-model="notification.description" name="rule" rows="3" />
          </div>
        </div>
        
        <NotificationTab :currentCondition="notificationOption.currentCondition" @updateCurrentCondition="updateCurrentCondition" />
        <div class="form-group" v-show="isShowUsers">
          <div>
            <textarea
              class="form-control"
              type="text"
              v-model="notificationOption.users"
              name="users"
              rows="3"
              placeholder="[1, 292, 33, 55]"
            />
          </div>
        </div>
        <div class="form-group" v-show="isShowUserIds">
          <div>
            <span><i>Needs to be separated by a newline.</i></span>
            <textarea
              class="form-control"
              type="text"
              v-model="notificationOption.userIds"
              name="userIds"
              rows="3"
              placeholder="123
456"
            />
          </div>
        </div>
        <div class="form-group" v-show="isShowEmails">
          <div>
            <span><i>Needs to be separated by a newline.</i></span>
            <textarea
              class="form-control"
              type="text"
              v-model="notificationOption.emails"
              name="emails"
              rows="3"
              placeholder="example@example.com
example02@example@example.com"
            />
          </div>
        </div>
        <div class="form-group" v-show="isShowRule">
          <div>
            <span><i>JsonLogic rule, e.g. plan, email domain, country or a combination — same rule format as stickers.</i></span>
            <textarea
              class="form-control"
              type="text"
              v-model="notificationOption.rule"
              name="rule"
              rows="3"
              placeholder='{"==":[{"var":"user.country"},"United States"]}'
            />
          </div>
        </div>
        <div class="text-center">
          <button type="submit" class="mr-2 btn btn-primary">
            Send Notification
            <i class="fa fa-spinner fa-spin" v-if="isCreatingNotification"></i>
          </button>
          <button type="button" class="btn btn-light" @click="hideAddStickerModal">Cancel</button>
        </div>
      </form>
    </aha-modal>
  </div>
</template>

<script>
import { withErrorRef } from '@/apiErrorRef'
import config from '@/config'
import { mapState } from 'vuex';
import utils  from "@/utils"
import NotificationTab from './notifications/NotificationTab.vue';

export default {
  data() {
    return {
      items: [],
      page: 1,
      size: 10,
      count: 0,
      isLoading: false,
      textSearch: "",
      isCreatingNotification: false,
      notificationOption: {
        users: '',
        userIds: '',
        emails: '',
        rule: '',
        currentCondition: 'users',
      },
      notification: {},
      showModal: false
    };
  },
  components: {
    NotificationTab,
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser
    }),
    isShowUserIds() {
      return this.notificationOption.currentCondition === 'userIds'
    },
    isShowUsers() {
      return this.notificationOption.currentCondition === 'users'
    },
    isShowEmails() {
      return this.notificationOption.currentCondition === 'emails'
    },
    isShowRule() {
      return this.notificationOption.currentCondition === 'rule'
    }
  },
  watch: {
    page: {
      handler: function() {
        this.getData();
      },
    }
  },
  mounted() {
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const res = await this.$http.get(config.api.getAllNotifications, {
        numberOfUsersPerPage: 200,
      });
      this.items = res.body.result;
      this.count = res.body.count;
      this.isLoading = false
    },
    search() {
      this.getData();
    },
    openAddStickerModal() {
      this.notification = {}
      this.resetNotificationOption()
      this.showModal = true
    },

    hideAddStickerModal() {
      this.showModal = false
    },

    getPayload(parsedRule) {
      const payload = JSON.parse(JSON.stringify(this.notification))
      if (this.notificationOption.currentCondition === 'users') {
        try {
          payload.users = JSON.parse(this.notificationOption.users)
        } catch {
          payload.users = 0
        }
      } else if (this.notificationOption.currentCondition === 'userIds') {
        payload.users = this.notificationOption.userIds
          .split('\n')
          .map(value => parseInt(value, 10))
      } else if (this.notificationOption.currentCondition === 'emails') {
        payload.emails = this.notificationOption.emails.split('\n')
      } else if (this.notificationOption.currentCondition === 'rule') {
        payload.rule = parsedRule
      }
      return payload
    },

    async sendNotification() {
      if (this.isCreatingNotification) return;

      let parsedRule
      if (this.notificationOption.currentCondition === 'rule') {
        try {
          parsedRule = JSON.parse(this.notificationOption.rule)
        } catch (e) {
          utils.showToastError('Target rule is not valid JSON: ' + e.message)
          return
        }
        // A JsonLogic rule must be a non-null object; a bare true/number/array
        // would target everyone or nobody rather than the intended audience.
        if (parsedRule === null || typeof parsedRule !== 'object' || Array.isArray(parsedRule)) {
          utils.showToastError('Target rule must be a JSON object, e.g. {"==":[{"var":"user.country"},"United States"]}')
          return
        }
      }

      this.isCreatingNotification = true

      try {
        const payload = this.getPayload(parsedRule)
        await this.$http.post(config.api.createNotification, payload)
        this.isCreatingNotification = false;
        this.notification = {}
        this.resetNotificationOption()
        utils.showToastSuccess('Sent New Notification')
        this.hideAddStickerModal()
        this.getData()
      } catch(error) {
        utils.showToastError(error.message || 'There is a problem sending notification')
      }
    },

    async onChangeThumbnail(event) {
      let file = event.target.files[0]
      if (!file) {
        this.notification = {
          ...this.notification,
          thumbnail: '',
          thumbnailFull: ''
        }
        console.log(this.notification)
        return
      }

      const maxSizeInBytes = 1 * 1024 * 1024; // 1MB

      if (file && file.size > maxSizeInBytes) {
        this.errorMessage = 'File size exceeds 1MB limit.';
        utils.showToastError('File size exceeds 1MB limit.')

        this.$refs.fileInputThumbnail.value = ''
        return
      }

      this.isCreatingNotification = true
      let formData = new FormData()
      formData.append("file", file)
      const resp = await this.$http.post(config.api.uploadImage, formData)
      this.isCreatingNotification = false
      this.notification.thumbnail = resp.body.file.key
      this.notification.thumbnailFull = resp.body.file.location
    },

    async onChangeImage(event) {
      let file = event.target.files[0]
      if (!file) {
        this.notification = {
          ...this.notification,
          image: '',
          imageFull: ''
        }
        return
      }

      const maxSizeInBytes = 1 * 1024 * 1024; // 1MB

      if (file && file.size > maxSizeInBytes) {
        this.errorMessage = 'File size exceeds 1MB limit.';
        utils.showToastError('File size exceeds 1MB limit.')

        this.$refs.fileInputImage.value = ''
        return
      }

      this.isCreatingNotification = true
      let formData = new FormData()
      formData.append("file", file)
      const resp = await this.$http.post(config.api.uploadImage, formData)
      this.isCreatingNotification = false
      this.notification.image = resp.body.file.key
      this.notification.imageFull = resp.body.file.location
    },

    resetNotificationOption() {
      this.notificationOption = {
        users: '',
        userIds: '',
        emails: '',
        rule: '',
        currentCondition: 'users',
      }
    },

    editSticker(sticker) {
      this.$router.push({ name: "StickerDetail", params: { id: sticker.id} })
    },

    async deleteNotification(item) {
      const isConfirmed = await this.$bvModal.msgBoxConfirm(`Are you sure to remove sticker: ${item.title}?`)
      if (isConfirmed) {
        try {
          this.isLoading = true
          this.$http.patch(config.api.updateNotification + item.id, {
            deleted: true
          })
          this.getData();
        } catch (err) {
          this.$bvModal.msgBoxOk(err && err.body && err.body.message || withErrorRef(err, 'There is a problem deleting notifications'))
        }
        this.isLoading = true
      }
    },

    updateCurrentCondition(value) {
      this.notificationOption.currentCondition = value
    }
  },
};
</script>
